import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Bar = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${layout.borderRadiusFull};
  min-height: ${space[7]};
`;

export const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${space[3]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  background: transparent;
  border: none;
  border-radius: ${layout.borderRadiusFull};
  padding: ${space[3]} ${space[5]};
  cursor: pointer;
  white-space: nowrap;
  transition: font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &[disabled] {
    cursor: default;
  }
`;

export const DotSeparator = styled.span`
  color: ${semantic.text.tertiary};
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  pointer-events: none;
`;
